import { useCurrentClient } from '@/composables/useCurrentClient'

/**
 * До монтирования страниц восстанавливаем current_client_id из localStorage
 * и загружаем список организаций — иначе useApi уходит без X-Client-Id.
 */
export default defineNuxtPlugin(async () => {
  if (!localStorage.getItem('access_token')) return
  if (localStorage.getItem('is_system') === '1') return

  const { init } = useCurrentClient()
  await init()
})
